// extracted by mini-css-extract-plugin
module.exports = {"JumpLink":"JumpLink_JumpLink__S71Fw","spindindust":"JumpLink_spindindust__HrhNL"};